import * as actionTypes from '../actions/actionTypes';


const initState = {
  currentLang:{
    lang:'English'
  },
  translatedData :{
    data:{}
  },
  currentLangFlag:{
    flag:'false'
  }
}

export default function multiLangReducer(state = initState, action){
  switch(action.type){
    case actionTypes.SET_LANGUAGE:{
      let _currentLang = {...state.currentLang};
      _currentLang.lang = action.lang;
        return {...state, currentLang: _currentLang};
    }
    case actionTypes.SET_TRANSLATED_DATA:{
      let _currentTranslatedData ={...state.currentTranslatedData};
      _currentTranslatedData.data = action.translatedData;
      return {...state, translatedData: _currentTranslatedData}
    }
    case actionTypes.SET_LANGUAGE_FLAG:{
      let _currentLangFlag = {...state.currentLangFlag};
      _currentLangFlag.flag = action.flag;
        return {...state, currentLangFlag: _currentLangFlag}
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/layouts/reducers/multiLangReducer.js